import { render, staticRenderFns } from "./alert_reason.vue?vue&type=template&id=55b7e35d&scoped=true&"
import script from "./alert_reason.vue?vue&type=script&lang=js&"
export * from "./alert_reason.vue?vue&type=script&lang=js&"
import style0 from "./alert_reason.vue?vue&type=style&index=0&id=55b7e35d&lang=scss&scoped=scoped&"
import style1 from "./alert_reason.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b7e35d",
  null
  
)

export default component.exports